import {
  ComponentWithAs,
  Flex,
  FlexProps,
  Icon,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";
import { SearchResult } from "./MapSearch";

type Props = {
  searchResult: SearchResult;
  onClick?: () => void;
  highlight?: boolean;
};

const SearchResultRow = ({ searchResult, onClick }: Props) => {
  const hoverColour = useColorModeValue("blackAlpha.50", "whiteAlpha.100");

  return (
    <Flex
      gap={3}
      p={3}
      alignItems="center"
      _hover={{ bg: hoverColour }}
      rounded="md"
      cursor="pointer"
      transition=".1s background"
      as={Link}
      to={searchResult.to}
      onClick={onClick}
    >
      <Icon
        as={searchResult.icon}
        w={7}
        h={7}
        color={searchResult.iconColour}
      />
      <Stack spacing={0} flex={1}>
        <Stack spacing={0}>
          <Flex justify="space-between" alignItems="center">
            <Text
              textTransform="capitalize"
              dangerouslySetInnerHTML={{
                __html: searchResult.title,
              }}
            />
            {searchResult.tag ? (
              <Text
                fontSize="sm"
                dangerouslySetInnerHTML={{
                  __html: searchResult.tag,
                }}
                opacity={0.8}
              />
            ) : null}
          </Flex>
          {searchResult.subtitle ? (
            <Text
              fontSize="sm"
              dangerouslySetInnerHTML={{
                __html: searchResult.subtitle,
              }}
            />
          ) : null}
        </Stack>
        {searchResult.description ? (
          <Text
            fontSize="sm"
            opacity={0.8}
            dangerouslySetInnerHTML={{ __html: searchResult.description }}
          />
        ) : null}
      </Stack>
    </Flex>
  );
};

export default SearchResultRow;
